import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

function LegalSection({ title, children }) {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" component="h2" sx={{ fontWeight: 700, mb: 1 }}>
        {title}
      </Typography>
      {children}
    </Box>
  );
}

function Terms() {
  return (
    <Box sx={{ maxWidth: 720 }}>
      <Typography variant="h4" component="h1" sx={{ fontWeight: 700, mb: 1 }}>
        Vilkår for brug
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Senest opdateret: 28. august 2026
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Ved at bruge sorenkoelbaek.dk (&quot;sitet&quot;) accepterer du disse vilkår. Sitet er
        et privat, invitationsbaseret website.
      </Typography>

      <LegalSection title="Konto og adgang">
        <Typography variant="body1">
          Adgang kræver en gyldig invitation og en konto. Du er ansvarlig for at
          holde dit login fortroligt. Vi kan suspendere eller slette en konto ved
          misbrug eller brud på vilkårene.
        </Typography>
      </LegalSection>

      <LegalSection title="Indhold">
        <Typography variant="body1">
          Indhold på sitet tilhører indehaveren eller den, der har lagt det op.
          Du må ikke misbruge sitet, forsøge uautoriseret adgang eller lægge
          ulovligt materiale op.
        </Typography>
      </LegalSection>

      <LegalSection title="Økonomi- og bankfunktion">
        <Typography variant="body1" sx={{ mb: 1.5 }}>
          Sitet kan indeholde en økonomioversigt, der henter konto- og
          transaktionsdata via Enable Banking, efter login og samtykke i banken.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1.5 }}>
          <strong>
            Funktionen er udelukkende tilgængelig for den udpegede administrator
            på platformen.
          </strong>{" "}
          Almindelige brugere har ingen adgang til økonomisider, bankforbindelser
          eller transaktioner — hverken i menuen, via direkte links eller via API.
        </Typography>
        <Typography variant="body1">
          En administrator ser kun sine egne data: konti og transaktioner, som
          administratoren selv har godkendt adgang til. Administratoren får ikke
          adgang til andre brugeres økonomiske oplysninger. Økonomioversigten er
          et privat hjælpemiddel og udgør ikke rådgivning, bogføring eller et
          officielt bankudtog.
        </Typography>
      </LegalSection>

      <LegalSection title="Tredjeparter">
        <Typography variant="body1">
          Bankforbindelse sker gennem Enable Banking og din bank. Deres vilkår og
          privatlivspolitik gælder for den del af forløbet, der sker hos dem. Vi
          er ikke ansvarlige for bankens eller Enable Bankings drift, fejl eller
          afbrydelser.
        </Typography>
      </LegalSection>

      <LegalSection title="Ansvar">
        <Typography variant="body1">
          Sitet stilles til rådighed som det er. Vi bestræber os på, at det virker,
          men garanterer ikke uafbrudt eller fejlfri drift. I det omfang loven
          tillader det, er vi ikke ansvarlige for indirekte tab.
        </Typography>
      </LegalSection>

      <LegalSection title="Ændringer">
        <Typography variant="body1">
          Vi kan opdatere disse vilkår. Den gældende version offentliggøres på
          denne side. Fortsat brug efter en ændring betyder, at du accepterer den
          nye version.
        </Typography>
      </LegalSection>

      <LegalSection title="Lovvalg">
        <Typography variant="body1">
          Vilkårene er underlagt dansk ret. Tvister afgøres ved danske domstole,
          medmindre ufravigelig forbrugerret giver andet værneting.
        </Typography>
      </LegalSection>
    </Box>
  );
}

export default Terms;
